export default "__VITE_ASSET__BDgA5zcD__"